module.exports = __webpack_public_path__ + "static/media/galerija_2021 (32).1665bc82.jpg";